import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import { RequiredAsterisk } from "../../../components/professional/RequiredAsterisk";
import Select from "../../../components/common/Select";


const ApplicationDetailsStep = ({
  data,
  onChange,
  errors,
  jobId,
  dropDownOptions,
}) => {
  const { visibilityChoices, statusChoices, interviewModeChoices } =
    dropDownOptions;

  return (
    <Box component="form" noValidate>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label={
              <span>
                Contact Email <RequiredAsterisk />
              </span>
            }
            value={data.contact_email}
            error={!!errors.contact_email}
            helperText={errors.contact_email}
            onChange={(e) => onChange("contact_email", e.target.value)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Application URL"
            value={data.application_url}
            onChange={(e) => onChange("application_url", e.target.value)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Select
            error={!!errors.interview_mode}
            helperText={errors.interview_mode}
            label="Interview Mode"
            onChange={(value) => onChange("interview_mode", value)}
            options={interviewModeChoices}
            value={data.interview_mode}
          />
          {/* <TextField
            select
            fullWidth
            label="Interview Mode"
            value={data.interview_mode}
            onChange={(e) => onChange("interview_mode", e.target.value)}
          >
            {interviewModeChoices?.map((mode) => (
              <MenuItem key={mode.value} value={mode.value}>
                {mode.label}
              </MenuItem>
            ))}
          </TextField> */}
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            // select
            fullWidth
            label="Candidate Communication"
            value={data.candidate_communication_type}
            onChange={(e) =>
              onChange("candidate_communication_type", e.target.value)
            }
          />
          {/* {communicationTypes.map((c) => (
              <MenuItem key={c} value={c}>
                {c}
              </MenuItem>
            ))}
          </TextField> */}
        </Grid>

        {/* Salary Min/Max */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            type="number"
            label="Minimum Salary"
            value={data.salary_min}
            error={errors.salary_min}
            helperText={errors.salary_min}
            onChange={(e) => onChange("salary_min", e.target.value)}
            slotProps={{ htmlInput: { min: 0 } }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            type="number"
            label="Maximum Salary"
            value={data.salary_max}
            onChange={(e) => onChange("salary_max", e.target.value)}
            slotProps={{ htmlInput: { min: 0 } }}
          />
        </Grid>

        {/* Dates */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            type="date"
            fullWidth
            label="Expected Start Date"
            // InputLabelProps={{ shrink: true }}
            slotProps={{ inputLabel: { shrink: true } }}
            value={data.expected_start_date}
            onChange={(e) => onChange("expected_start_date", e.target.value)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            type="date"
            fullWidth
            label="Expiry Date"
            // InputLabelProps={{ shrink: true }}
            slotProps={{ inputLabel: { shrink: true } }}
            value={data.expiry_date}
            onChange={(e) => onChange("expiry_date", e.target.value)}
          />
        </Grid>
        {jobId && (
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              select
              fullWidth
              label="Status"
              value={data.status}
              onChange={(e) => onChange("status", e.target.value)}
            >
              {statusChoices.map((status) => (
                <MenuItem key={status.value} value={status.value}>
                  {status.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        )}
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            select
            fullWidth
            label="Visibility"
            value={data.visibility}
            onChange={(e) => onChange("visibility", e.target.value)}
          >
            {visibilityChoices.map((choice) => (
              <MenuItem key={choice.value} value={choice.value}>
                {choice.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Urgent checkbox */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={data.is_urgent || false}
                onChange={(e) => onChange("is_urgent", e.target.checked)}
              />
            }
            label="Mark as Urgent"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ApplicationDetailsStep;
